import produce from 'immer';
import { RequestsAction } from '../actions/Requests';
import * as Constants from '../constants/action-constants';
import initialState from '../InitialState';
import { Requests } from '../types/Requests';
const requests = (
  state: Requests = initialState.requests,
  action: RequestsAction
): Requests => {
  return produce<Requests, Requests>(state, draft => {
    switch (action.type) {
      case Constants.POLL_REQUESTS:
        draft.fetching = true;
        draft.failed = false;
        break;
      case Constants.POLL_REQUESTS_SUCCESS:
        draft.fetching = false;
        draft.data.requests = action.payload.requests;
        break;
      case Constants.POLL_REQUESTS_FAILED:
        draft.fetching = false;
        draft.failed = true;
        break;
      case Constants.MANAGE_PAGE_CHANGE:
        draft.data.currentPage = action.payload.page;
        break;
      case Constants.MANAGE_PAGE_SIZE_CHANGE:
        draft.data.pageSize = action.payload.pageSize;
        draft.data.currentPage = 1;
        break;
      case Constants.MANAGE_FILTERS_CHANGE:
        draft.data.filters = action.payload.filters;
        break;
      case Constants.MANAGE_SORT_CHANGE:
        draft.data.sort = action.payload.sort;
        break;
      case Constants.DELETE_REQUEST:
        if (draft.data.requests) {
          const index = draft.data.requests.content.findIndex(
            r => r.vmid === action.payload.requestId
          );
          draft.data.requests.content.splice(index, 1);
        }
        break;
      // no default
    }
  });
};

export default requests;
